import { forwardRef, type RefAttributes } from 'react'
import { Button, type ButtonProps, Text } from '@grammarly/design-system'

import { AnimatedCounter } from '../animatedCounter'
import styles from './SuggestionCounterButton.module.scss'

interface Props extends ButtonProps, RefAttributes<HTMLButtonElement> {
  title: string
  suggestions: number
  /** Custom animation duration in milliseconds. Defaults to CSS value or 200ms */
  animationDuration?: number
}

// TODO: (ivan.german) implement a success state for this button
export const SuggestionCounterButton = forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const { title, suggestions, animationDuration, ...remainingProps } = props

  return (
    <Button
      ref={ref}
      variant="secondary"
      className={styles.animatedCounterButton}
      aria-label={`${title}: ${suggestions} suggestions`}
      {...remainingProps}
    >
      <Text as="p" variant="text-small" weight="medium">
        {title}
      </Text>
      <AnimatedCounter
        value={suggestions}
        animationDuration={animationDuration}
        variant="text-xsmall"
        color="base-subdued"
      />
    </Button>
  )
})
